let scrollTo = {
    init: () => {
        const scrollTos = document.querySelectorAll('.js-scroll-to');

        const scrollToElement = () => {
            return (e) => {
                const nav = document.getElementById('scrollToNav');
                const topOffset = nav ? nav.clientHeight : 0;
                const scrollTo = e.target;
                const scrollElement = document.getElementById(scrollTo.dataset.target);

                const offsetPosition = scrollElement.getBoundingClientRect().top + window.pageYOffset - topOffset;
    
                scrollTo.closest("nav")
                    .querySelectorAll(".js-scroll-to")
                    .forEach(el => el.classList.remove("active"));
    
                scrollTo.classList.add("active");

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth"
               });
            }
        }

        if (scrollTos) {
            for (const scrollTo of scrollTos) {
                scrollTo.addEventListener("click", scrollToElement());
            }
        }
    }
}

export default scrollTo;